import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import {
  SETTING_TAB_WIDGET_KEYS
} from "../../other/constants/OtherKeys.jsx";
import { tagWidget } from "../../other/utils/otherUtils.jsx";
import { getCustomGroupRenderer } from "../../other/utils/utils.jsx";
import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { EDITOR_KEYS } from "../../other/constants/EditorKeys.jsx";

class TeamColumn extends SwivuSortColumn {
  static get $name() {
    return "TeamColumn";
  }

  get swivuIsTagColumn() {
    return true;
  }

  static get type() {
    return WIDGET_KEYS.teamField;
  }

  static get defaults() {
    return {
      groupRenderer(event) {
        return getCustomGroupRenderer(event);
      }
    };
  }

  static isMatchValues(teamId, value) {
    if (teamId) {
      return teamId === value;
    }
    return false;
  }

  static get fields() {
    return [{ name: "swivuListTitle", type: "string", defaultValue: "Team" }]
  }

  onLoad(project, otherParams) {
    super.onLoad(project);
    this.project = project;
    this.editorHandler = otherParams.editorHandler;
  }

  get swivuListItems() {
    return this.project
      .getCrudStore(STORE_KEYS.boardTeamsStore)
      .query(() => true, true);
  }

  getSwivuListItemDisplayValue(record) {
    return record.name;
  }

  getSelectedSwivuListItem(record) {
    return record._team?.id
  }

  onSwivuListSelectionChange(record, [selectedTeamRecord]) {
    record._team = selectedTeamRecord?.id;
  }

  onSwivuManageList() {
    this.editorHandler.openEditor(
      EDITOR_KEYS.settingGeneralEditor,
      null,
      {
        selectTabByTypeOnOpen: SETTING_TAB_WIDGET_KEYS.teamsTab
      },
      { by: "recordType", useExisting: true }
    );
  }

  defaultRenderer({ record }) {
    const teamRecord = record._team;
    return tagWidget(teamRecord?.name);
  }
}

ColumnStore.registerColumnType(TeamColumn);
